// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./system.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./custom.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/*
    Contains constants for the z-index values of elements that are part of the global stack context.
    In other words, z-index values that are "inside" a component are not added here.
    This prevents conflicts between identical z-index values in different components.
*/

/* Toolbox z-index: 40; set in scratch-blocks */

/* tooltips should go over add buttons if they overlap */

/* monitors go over add buttons */

/* "ask" block text input goes above monitors */

/* menu-bar should go over monitors, alerts and tutorials */

/* behind menu-bar */

/* Block drag z-index: 1000; default 50 is overriden in blocks.css */

/* so it is draggable into other panes */

/* behind modals */

/* behind modals */

/* in most interfaces, the context menu is always on top */

.fonts-modal_modal-content_fBz6q {
    max-width: 550px;
    margin-top: 50px;
}

.fonts-modal_body_snedx {
    background: var(--ui-modal-background);
    padding: 1.5rem 2.25rem;
    max-height: calc(100vh - 150px);
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.fonts-modal_open-buttons_Ig8li {
    display: flex;
    gap: 1rem;
}

.fonts-modal_open-button_ZsPUG {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    width: 100%;
    align-items: center;
    background: none;
    padding: 0.5rem;
    margin: 0;
    border: 2px solid var(--ui-black-transparent);
    border-radius: 0.5rem;
}

.fonts-modal_open-button_ZsPUG:hover {
    color: var(--looks-secondary);
    border-color: var(--looks-secondary);
}

.fonts-modal_open-button-image_nNbEj {
    width: 64px;
    height: 64px;
    background-color: currentColor;
    -webkit-mask-size: cover;
            mask-size: cover;
    -webkit-mask-repeat: no-repeat;
            mask-repeat: no-repeat;
}

.fonts-modal_system-image_kJuTw {
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
            mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.fonts-modal_custom-image_vJ0sI {
    -webkit-mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
            mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.fonts-modal_open-button-text_Z8jSY {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.fonts-modal_open-button-text-main_pVdU8 {
    font-weight: bold;
}

.fonts-modal_open-button-text-sub_O6EE0 {

}

.fonts-modal_font-input-outer_sFzWh {

}

.fonts-modal_font-input_RuZfd {
    width: 100%;
    border: 1px solid var(--ui-black-transparent);
    border-radius: 0.25rem;
    padding: 0 1rem;
    height: 3rem;
    font: inherit;
    color: var(--text-primary);
    background-color: var(--input-background);
}

.fonts-modal_font-dropdown-outer_tNGrG {
    position: absolute;
    z-index: 510;
    background-color: var(--ui-white);
    color: var(--text-primary);
    border-radius: 0.25rem;
    overflow: auto;
    max-height: 300px;
    border: 1px solid var(--ui-black-transparent);
    box-sizing: border-box;
    box-shadow: 0px 0px 8px 1px var(--shadow);
}

.fonts-modal_font-dropdown-item_WpCxx {
    display: flex;
    align-items: center;
    padding: 0.5rem 0.75rem;
    height: 1.5rem;
    cursor: pointer;
    transition: .1s ease;
}

.fonts-modal_font-dropdown-item_WpCxx:hover {
    background-color: var(--looks-secondary);
    color: #ffffff;
}

.fonts-modal_font-playground_Xidh0 {
    background: none;
    border: none;
    padding: 0.5rem;
    margin: 0;
    resize: none;
    width: 100%;
    height: 100px;
    font-size: 1.5rem;
    border: 1px solid var(--ui-black-transparent);
    border-radius: 0.25rem;
}

.fonts-modal_button_i4rkh {
    font: inherit;
    font-weight: bold;
    padding: 0.75rem 1rem;
    border-radius: 0.25rem;
    border: 1px solid var(--ui-black-transparent);
    background-color: var(--looks-secondary);
    color: white;
}

.fonts-modal_button_i4rkh:disabled {
    opacity: 0.8;
}

.fonts-modal_fallback-container_l8PRW {
    display: flex;
    flex-direction: column;
}

.fonts-modal_fallback-label_ZZOPx {
    margin-bottom: 0.5rem;
}

.fonts-modal_fallback-list_Xp8ES {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 0.25rem
}

.fonts-modal_fallback-button_FpfeE {
    background: none;
    padding: 0;
    border: 0;
    border-radius: 0.25rem;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.fonts-modal_fallback-button_FpfeE:hover {
    color: var(--looks-secondary);
}

.fonts-modal_fallback-container_l8PRW .fonts-modal_fallback-button-selected_CZxvk {
    background-color: var(--looks-secondary);
    color: white;
}

.fonts-modal_fonts-outer_dT05k {
    border-top: 2px solid var(--ui-black-transparent);
    padding-top: 1rem;
}

.fonts-modal_fonts-outer_dT05k p {
    margin-bottom: 0.5rem;
}

.fonts-modal_fonts_jYs5S {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.fonts-modal_manage-font_q0PZY {
    width: 100%;
    display: flex;
    align-items: center;
    border: 2px solid var(--ui-black-transparent);
    border-radius: 0.5rem;
    padding: 0.5rem;
    gap: 0.5rem;
}

.fonts-modal_manage-font-name_VIBD4 {
    font-size: 2rem;
    margin-bottom: 0.5rem;
    overflow-wrap: anywhere;
}

.fonts-modal_manage-font-buttons_VoUWV {
    margin-left: auto;
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    gap: 0.5rem;
}

.fonts-modal_manage-font-button_khoHl {
    background: none;
    border: none;
    border-radius: 100%;
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.fonts-modal_manage-font-button_khoHl:hover {
    background-color: var(--ui-black-transparent);
}

.fonts-modal_manage-font-button_khoHl img {
    display: block;
    width: 100%;
    height: 100%;
    filter: var(--filter-icon-black);
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-fonts-modal/fonts-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;;;;CAIC;;AAED,+CAA+C;;AAE/C,wDAAwD;;AAExD,iCAAiC;;AAEjC,+CAA+C;;AAE/C,2DAA2D;;AAE3D,oBAAoB;;AAEpB,oEAAoE;;AAEpE,wCAAwC;;AAExC,kBAAkB;;AAElB,kBAAkB;;AAElB,0DAA0D;;AAE1D;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;IACvB,+BAA+B;IAC/B,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,6CAA6C;IAC7C,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,wBAAwB;YAChB,gBAAgB;IACxB,8BAA8B;YACtB,sBAAsB;AAClC;;AAEA;IACI,2DAAqC;YAC7B,mDAA6B;AACzC;;AAEA;IACI,2DAAqC;YAC7B,mDAA6B;AACzC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;IACI,WAAW;IACX,6CAA6C;IAC7C,sBAAsB;IACtB,eAAe;IACf,YAAY;IACZ,aAAa;IACb,0BAA0B;IAC1B,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iCAAiC;IACjC,0BAA0B;IAC1B,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,6CAA6C;IAC7C,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,SAAS;IACT,YAAY;IACZ,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,6CAA6C;IAC7C,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;IACtB,6CAA6C;IAC7C,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC;AACJ;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,wCAAwC;IACxC,YAAY;AAChB;;AAEA;IACI,iDAAiD;IACjD,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,6CAA6C;IAC7C,qBAAqB;IACrB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,gCAAgC;AACpC","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/*\n    Contains constants for the z-index values of elements that are part of the global stack context.\n    In other words, z-index values that are \"inside\" a component are not added here.\n    This prevents conflicts between identical z-index values in different components.\n*/\n\n/* Toolbox z-index: 40; set in scratch-blocks */\n\n/* tooltips should go over add buttons if they overlap */\n\n/* monitors go over add buttons */\n\n/* \"ask\" block text input goes above monitors */\n\n/* menu-bar should go over monitors, alerts and tutorials */\n\n/* behind menu-bar */\n\n/* Block drag z-index: 1000; default 50 is overriden in blocks.css */\n\n/* so it is draggable into other panes */\n\n/* behind modals */\n\n/* behind modals */\n\n/* in most interfaces, the context menu is always on top */\n\n.modal-content {\n    max-width: 550px;\n    margin-top: 50px;\n}\n\n.body {\n    background: var(--ui-modal-background);\n    padding: 1.5rem 2.25rem;\n    max-height: calc(100vh - 150px);\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.open-buttons {\n    display: flex;\n    gap: 1rem;\n}\n\n.open-button {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    width: 100%;\n    align-items: center;\n    background: none;\n    padding: 0.5rem;\n    margin: 0;\n    border: 2px solid var(--ui-black-transparent);\n    border-radius: 0.5rem;\n}\n\n.open-button:hover {\n    color: var(--looks-secondary);\n    border-color: var(--looks-secondary);\n}\n\n.open-button-image {\n    width: 64px;\n    height: 64px;\n    background-color: currentColor;\n    -webkit-mask-size: cover;\n            mask-size: cover;\n    -webkit-mask-repeat: no-repeat;\n            mask-repeat: no-repeat;\n}\n\n.system-image {\n    -webkit-mask-image: url(./system.svg);\n            mask-image: url(./system.svg);\n}\n\n.custom-image {\n    -webkit-mask-image: url(./custom.svg);\n            mask-image: url(./custom.svg);\n}\n\n.open-button-text {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n}\n\n.open-button-text-main {\n    font-weight: bold;\n}\n\n.open-button-text-sub {\n\n}\n\n.font-input-outer {\n\n}\n\n.font-input {\n    width: 100%;\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: 0.25rem;\n    padding: 0 1rem;\n    height: 3rem;\n    font: inherit;\n    color: var(--text-primary);\n    background-color: var(--input-background);\n}\n\n.font-dropdown-outer {\n    position: absolute;\n    z-index: 510;\n    background-color: var(--ui-white);\n    color: var(--text-primary);\n    border-radius: 0.25rem;\n    overflow: auto;\n    max-height: 300px;\n    border: 1px solid var(--ui-black-transparent);\n    box-sizing: border-box;\n    box-shadow: 0px 0px 8px 1px var(--shadow);\n}\n\n.font-dropdown-item {\n    display: flex;\n    align-items: center;\n    padding: 0.5rem 0.75rem;\n    height: 1.5rem;\n    cursor: pointer;\n    transition: .1s ease;\n}\n\n.font-dropdown-item:hover {\n    background-color: var(--looks-secondary);\n    color: #ffffff;\n}\n\n.font-playground {\n    background: none;\n    border: none;\n    padding: 0.5rem;\n    margin: 0;\n    resize: none;\n    width: 100%;\n    height: 100px;\n    font-size: 1.5rem;\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: 0.25rem;\n}\n\n.button {\n    font: inherit;\n    font-weight: bold;\n    padding: 0.75rem 1rem;\n    border-radius: 0.25rem;\n    border: 1px solid var(--ui-black-transparent);\n    background-color: var(--looks-secondary);\n    color: white;\n}\n\n.button:disabled {\n    opacity: 0.8;\n}\n\n.fallback-container {\n    display: flex;\n    flex-direction: column;\n}\n\n.fallback-label {\n    margin-bottom: 0.5rem;\n}\n\n.fallback-list {\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr;\n    gap: 0.25rem\n}\n\n.fallback-button {\n    background: none;\n    padding: 0;\n    border: 0;\n    border-radius: 0.25rem;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.fallback-button:hover {\n    color: var(--looks-secondary);\n}\n\n.fallback-container .fallback-button-selected {\n    background-color: var(--looks-secondary);\n    color: white;\n}\n\n.fonts-outer {\n    border-top: 2px solid var(--ui-black-transparent);\n    padding-top: 1rem;\n}\n\n.fonts-outer p {\n    margin-bottom: 0.5rem;\n}\n\n.fonts {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.manage-font {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    border: 2px solid var(--ui-black-transparent);\n    border-radius: 0.5rem;\n    padding: 0.5rem;\n    gap: 0.5rem;\n}\n\n.manage-font-name {\n    font-size: 2rem;\n    margin-bottom: 0.5rem;\n    overflow-wrap: anywhere;\n}\n\n.manage-font-buttons {\n    margin-left: auto;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: row;\n    gap: 0.5rem;\n}\n\n.manage-font-button {\n    background: none;\n    border: none;\n    border-radius: 100%;\n    width: 2rem;\n    height: 2rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.manage-font-button:hover {\n    background-color: var(--ui-black-transparent);\n}\n\n.manage-font-button img {\n    display: block;\n    width: 100%;\n    height: 100%;\n    filter: var(--filter-icon-black);\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `fonts-modal_modal-content_fBz6q`;
export { _1 as "modal-content" };
export var modalContent = `fonts-modal_modal-content_fBz6q`;
export var body = `fonts-modal_body_snedx`;
var _2 = `fonts-modal_open-buttons_Ig8li`;
export { _2 as "open-buttons" };
export var openButtons = `fonts-modal_open-buttons_Ig8li`;
var _3 = `fonts-modal_open-button_ZsPUG`;
export { _3 as "open-button" };
export var openButton = `fonts-modal_open-button_ZsPUG`;
var _4 = `fonts-modal_open-button-image_nNbEj`;
export { _4 as "open-button-image" };
export var openButtonImage = `fonts-modal_open-button-image_nNbEj`;
var _5 = `fonts-modal_system-image_kJuTw`;
export { _5 as "system-image" };
export var systemImage = `fonts-modal_system-image_kJuTw`;
var _6 = `fonts-modal_custom-image_vJ0sI`;
export { _6 as "custom-image" };
export var customImage = `fonts-modal_custom-image_vJ0sI`;
var _7 = `fonts-modal_open-button-text_Z8jSY`;
export { _7 as "open-button-text" };
export var openButtonText = `fonts-modal_open-button-text_Z8jSY`;
var _8 = `fonts-modal_open-button-text-main_pVdU8`;
export { _8 as "open-button-text-main" };
export var openButtonTextMain = `fonts-modal_open-button-text-main_pVdU8`;
var _9 = `fonts-modal_open-button-text-sub_O6EE0`;
export { _9 as "open-button-text-sub" };
export var openButtonTextSub = `fonts-modal_open-button-text-sub_O6EE0`;
var _a = `fonts-modal_font-input-outer_sFzWh`;
export { _a as "font-input-outer" };
export var fontInputOuter = `fonts-modal_font-input-outer_sFzWh`;
var _b = `fonts-modal_font-input_RuZfd`;
export { _b as "font-input" };
export var fontInput = `fonts-modal_font-input_RuZfd`;
var _c = `fonts-modal_font-dropdown-outer_tNGrG`;
export { _c as "font-dropdown-outer" };
export var fontDropdownOuter = `fonts-modal_font-dropdown-outer_tNGrG`;
var _d = `fonts-modal_font-dropdown-item_WpCxx`;
export { _d as "font-dropdown-item" };
export var fontDropdownItem = `fonts-modal_font-dropdown-item_WpCxx`;
var _e = `fonts-modal_font-playground_Xidh0`;
export { _e as "font-playground" };
export var fontPlayground = `fonts-modal_font-playground_Xidh0`;
export var button = `fonts-modal_button_i4rkh`;
var _f = `fonts-modal_fallback-container_l8PRW`;
export { _f as "fallback-container" };
export var fallbackContainer = `fonts-modal_fallback-container_l8PRW`;
var _10 = `fonts-modal_fallback-label_ZZOPx`;
export { _10 as "fallback-label" };
export var fallbackLabel = `fonts-modal_fallback-label_ZZOPx`;
var _11 = `fonts-modal_fallback-list_Xp8ES`;
export { _11 as "fallback-list" };
export var fallbackList = `fonts-modal_fallback-list_Xp8ES`;
var _12 = `fonts-modal_fallback-button_FpfeE`;
export { _12 as "fallback-button" };
export var fallbackButton = `fonts-modal_fallback-button_FpfeE`;
var _13 = `fonts-modal_fallback-button-selected_CZxvk`;
export { _13 as "fallback-button-selected" };
export var fallbackButtonSelected = `fonts-modal_fallback-button-selected_CZxvk`;
var _14 = `fonts-modal_fonts-outer_dT05k`;
export { _14 as "fonts-outer" };
export var fontsOuter = `fonts-modal_fonts-outer_dT05k`;
export var fonts = `fonts-modal_fonts_jYs5S`;
var _15 = `fonts-modal_manage-font_q0PZY`;
export { _15 as "manage-font" };
export var manageFont = `fonts-modal_manage-font_q0PZY`;
var _16 = `fonts-modal_manage-font-name_VIBD4`;
export { _16 as "manage-font-name" };
export var manageFontName = `fonts-modal_manage-font-name_VIBD4`;
var _17 = `fonts-modal_manage-font-buttons_VoUWV`;
export { _17 as "manage-font-buttons" };
export var manageFontButtons = `fonts-modal_manage-font-buttons_VoUWV`;
var _18 = `fonts-modal_manage-font-button_khoHl`;
export { _18 as "manage-font-button" };
export var manageFontButton = `fonts-modal_manage-font-button_khoHl`;
export default ___CSS_LOADER_EXPORT___;
